import React from 'react';

import { BaseLink } from '../BaseLink';

import CssClassNames from '../../scss/CssClassNames';
import moduledStyles from './styles.module.scss';
const { className } = new CssClassNames(moduledStyles, ['utility', 'text']);

export function Breadcrumb({
  links = [],
  wrapperClassName = null,
  liClassName = null,
  linkClassName = null
}) {
  return (
    <nav aria-label="Rota de navegação" {...wrapperClassName && { className: wrapperClassName }}>
      <ol
        {...className('breadcrumb')}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {links.map((item, i) => {
          console.log(item)
          const isLast = links.length - 1 === i;

          return (
            <li
              key={i}
              {...className(`breadcrumb-item ${liClassName ? liClassName : ''} ${isLast ? 'active' : ''}`)}
              {...isLast && { 'aria-current': 'page' }}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {isLast ? (
                <span aria-label={`${item.title}, elemento ${i + 1} de ${links.length}`} itemProp="name">
                  <span aria-hidden="true">{item.title}</span>
                </span>
              ) : (
                <BaseLink
                  {...item}
                  {...linkClassName && { extraClassName: linkClassName }}
                  ariaLabelPriority={`${item.titleAlt ? item.titleAlt : item.title}, elemento ${i + 1} de ${links.length}`}
                  extraAttributes={{
                    itemProp: 'item',
                    href: item.href,
                  }}
                  title={
                    typeof item.title === 'string' ?
                      (<span itemProp="name">{item.title}</span>) :
                      (<>
                        {item.title}
                        {item.titleAlt ? (
                          <span {...className('d-none')} itemProp="name">{item.titleAlt}</span>
                        ) : null}
                      </>)
                  }
                />
              )}
              <meta itemProp="position" content={i + 1} />
            </li>
          );
        })}
      </ol>
    </nav>
  )
}
